import { forIn, isArray, random } from "lodash";
import { firestore, auth, Timestamp } from "../_firebase";
import Collection from "../_collections";
import { updateObject } from "../_utils";

const getConversations = filter => {
  let promise = new Promise((resolve, reject) => {
    const userId = auth.currentUser.uid;

    firestore
      .collection(Collection.USERS)
      .doc(userId)
      .collection(Collection.USER_CONVERSTATIONS)
      .orderBy("lastMessage", "desc")
      .limit(14)
      .get()
      .then(results => {
        let searchResults = [];
        results.forEach(result => {
          searchResults.push({ ...result.data(), ...{ id: result.id } });
        });
        let lastResult = null;
        if (results.size !== 0) {
          lastResult = results.docs[results.docs.length - 1].id;
        }
        resolve({ results: searchResults, lastResult });
      })
      .catch(err => {
        console.log(err);
        reject("Please try again later");
      });
  });
  return promise;
};

const send = (messagingId, message) => {
  let promise = new Promise((resolve, reject) => {
    const userId = auth.currentUser.uid;
    const updatedMessage = updateObject(message, {
      sender: userId,
      read: false,
      createdAt: Timestamp.now()
    });
    firestore
      .collection(Collection.MESSAGING)
      .doc(messagingId)
      .collection(Collection.CHAT_MESSAGES)
      .add(updatedMessage)
      .then(results => {
        resolve();
      })
      .catch(err => {
        console.log(err);
        reject("Please try again later");
      });
  });
  return promise;
};

const updateImageUrl = (selectedId, image) => {
  let promise = new Promise((resolve, reject) => {
    const userId = auth.currentUser.uid;
    firestore
      .collection(Collection.USERS)
      .doc(userId)
      .collection(Collection.USER_CONVERSTATIONS)
      .doc(selectedId)
      .update({
        "user.imageURL": image
      })
      .then(results => {
        resolve();
      })
      .catch(err => {
        console.log(err);
        reject("Please try again later");
      });
  });
  return promise;
};

const loadMoreMessages = (lastResult, messagingId) => {
  let promise = new Promise((resolve, reject) => {
    if (!lastResult) {
      reject("Please try again later");
    }

    firestore
      .collection(Collection.MESSAGING)
      .doc(messagingId)
      .collection(Collection.CHAT_MESSAGES)
      .doc(lastResult)
      .get()
      .then(doc => {
        firestore
          .collection(Collection.MESSAGING)
          .doc(messagingId)
          .collection(Collection.CHAT_MESSAGES)
          .orderBy("createdAt", "desc")
          .limit(10)
          .startAfter(doc)
          .get()
          .then(results => {
            let messages = [];

            results.forEach(result => {
              messages.push({ ...result.data(), ...{ id: result.id } });
            });
            let hasMoreResults = results.size === 0 ? false : true;
            let isLastResult = true;
            if (results.size !== 0) {
              isLastResult = false;
            }
            resolve({ messages, isLastResult });
          })
          .catch(err => {
            console.log(err);
            reject("Please try again later");
          });
      })
      .catch(err => {
        console.log(err);
        reject("Please try again later");
      });
  });
  return promise;
};

const loadMoreConversations = lastResult => {
  let promise = new Promise((resolve, reject) => {
    const userId = auth.currentUser.uid;

    if (!lastResult) {
      reject("Please try again later");
    }

    firestore
      .collection(Collection.USERS)
      .doc(userId)
      .collection(Collection.USER_CONVERSTATIONS)
      .doc(lastResult)
      .get()
      .then(doc => {
        if (doc.exists) {
          firestore
            .collection(Collection.USERS)
            .doc(userId)
            .collection(Collection.USER_CONVERSTATIONS)
            .startAfter(doc)
            .get()
            .then(results => {
              let conversationResults = [];

              results.forEach(result => {
                conversationResults.push({
                  ...result.data(),
                  ...{ id: result.id }
                });
              });
              let lastResult = null;
              if (results.size !== 0) {
                lastResult = results.docs[results.docs.length - 1].id;
              }

              resolve({ results: conversationResults, lastResult });
            })
            .catch(err => {
              console.log(err);
              reject("Please try again later");
            });
        } else {
          reject("Please try again later");
        }
      })
      .catch(err => {
        console.log(err);
        reject("Please try again later");
      });
  });
  return promise;
};

const messagingService = {
  getConversations,
  send,
  updateImageUrl,
  loadMoreMessages,
  loadMoreConversations
};
export default messagingService;



// WEBPACK FOOTER //
// ./src/_services/messagingService.js